export default __webpack_public_path__ + "static/media/signal-high.7c6486b7.svg";